<template>
  <div class="lucky-turntable">
    <img src="@/assets/lucky/turntable/table_bg.png" class="img-bg" alt="背景">
    <div v-if="prizeList.length > 0" class="prize-container">
      <div class="prize-row">
        <div :class="['prize-item', scrollIndex==1?'choose':'']">
          <img :src="prizeList[0].icon" alt="">
          <div v-html="prizeList[0].name"></div>
        </div>
        <div :class="['prize-item', scrollIndex==2?'choose':'']">
          <img :src="prizeList[1].icon" alt="">
          <div v-html="prizeList[1].name"></div>
        </div>
        <div :class="['prize-item', scrollIndex==3?'choose':'']">
          <img :src="prizeList[2].icon" alt="">
          <div v-html="prizeList[2].name"></div>
        </div>
      </div>
      <div class="prize-row">
        <div :class="['prize-item', scrollIndex==8?'choose':'']">
          <img :src="prizeList[7].icon" alt="">
          <div v-html="prizeList[7].name"></div>
        </div>
        <div class="prize-item prize-center">
            好运<br>转盘
        </div>
        <div :class="['prize-item', scrollIndex==4?'choose':'']">
          <img :src="prizeList[3].icon" alt="">
          <div v-html="prizeList[3].name"></div>
        </div>
      </div>
      <div class="prize-row">
        <div :class="['prize-item', scrollIndex==7?'choose':'']">
          <img :src="prizeList[6].icon" alt="">
          <div v-html="prizeList[6].name"></div>
        </div>
        <div :class="['prize-item', scrollIndex==6?'choose':'']">
          <img :src="prizeList[5].icon" alt="">
          <div v-html="prizeList[5].name"></div>
        </div>
        <div :class="['prize-item', scrollIndex==5?'choose':'']">
          <img :src="prizeList[4].icon" alt="">
          <div v-html="prizeList[4].name"></div>
        </div>
      </div>
    </div>
    <img src="@/assets/lucky/turntable/btn_icon.png" :class="['start_btn', isStarting?'play':'']" alt="" @click="startHandle">
  </div>
</template>

<script>
const config = {
  // 基础旋转数
  number: 8,
  circle: 6*8
}
export default {
  name: 'LuckyTurntable',
  props: {
    prizeList:{
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      config,
      index: 0, // 选中的物品
      isStarting: false, // 是否旋转
      scrollIndex: 0,
      scrollLast: 0
    };
  },
  methods: {
    startHandle() {
      if (this.isStarting) return
      this.$emit('start')
    },
    beginRotate(prize) {
      // prize 奖品列表的下标
      this.index = parseInt(prize)+1
      this.isStarting = true
      this.scrollLast = this.config.circle + this.index
      console.log('scrollLast:', this.scrollLast)
      this.scrollIndex = 0
      this.rotating()
    },
    rotating(){
      setTimeout(()=>{
        if(this.scrollLast <= 0){
          this.isStarting = false
          this.$emit('end')
          return
        }
        this.scrollLast--
        const i = (this.scrollIndex+1)%this.config.number
        this.scrollIndex = i == 0?this.config.number:i
        this.rotating()
      }, 60)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.lucky-turntable {
  position: relative;
  .img-bg{
    display: block;
    width: 100%;
  }
  .prize-container{
    position: absolute;
    width: 80vw;
    height: 80vw;
    top: 5vw;
    right: 10vw;
    .prize-row{
      display: flex;
      justify-content: space-around;
      .prize-item{
        border: solid transparent 4px;
        width: calc(80vw/3 - 6px - 8px);
        height: calc(78vw/3 - 22px - 8px);
        margin: 6px;
        background: linear-gradient(180deg, #FDFBD1 0%, #FEFDE9 100%);
        border-radius: 4px;
        padding: 3px 3px 6px 3px;
        font-size: 13px;
        line-height: 14px;
        color: #7E614E;
        img{
          width: 80%;
        }
        &.choose{
          border: solid #8E34FF 4px;
        }
      }
      .prize-center{
        background: transparent;
        color: #FEFFEA;
        font-weight: 600;
        font-size: 32px;
        line-height: calc(78vw/6 - 6px);
      }
    }
  }
  .start_btn{
    position: absolute;
    bottom: 0;
    right: 18vw;
    width: 64vw;
    transition: bottom 0.06s;
    &.play{
      bottom: -10px;
    }
  }
}
@media screen and (max-width: 370px) {
  .lucky-turntable{
    .prize-container{
      .prize-row{
        .prize-item{
          border: solid transparent 2px;
          width: calc(80vw/3 - 10px - 4px);
          height: calc(78vw/3 - 16px - 4px);
          margin: 5px;
          padding: 3px;
          font-size: 12px;
          img{
            width: 76%;
          }
          &.choose{
            border: solid #8E34FF 2px;
          }
        }
        .prize-center{
          font-size: 26px;
        }
      }
    }
  }
}
@media screen and (max-width: 320px) {
  .lucky-turntable{
    .prize-container{
      .prize-row{
        .prize-item{
          border: solid transparent 2px;
          width: calc(80vw/3 - 10px - 4px);
          height: calc(78vw/3 - 16px - 4px);
          margin: 5px;
          padding: 3px;
          font-size: 10px;
          img{
            width: 76%;
          }
          &.choose{
            border: solid #8E34FF 2px;
          }
        }
        .prize-center{
          font-size: 26px;
        }
      }
    }
  }
}
</style>
